import { AuthMessage, AuthMessageType } from '@playcastdotio/Messaging';
import { setIsReady } from '..';

type SignInTokenCallback = (token: string) => void;
type AuthErrorCallback = (error: { code?: string; message?: string }) => void;

let signInTokenCallback: SignInTokenCallback | null = null;
let authErrorCallback: AuthErrorCallback | null = null;

export const setSignInTokenCallback = (callback: SignInTokenCallback) => {
  signInTokenCallback = callback;
};

export const setAuthErrorCallback = (callback: AuthErrorCallback | null) => {
  authErrorCallback = callback;
};

export const handleAuthMessage = (message: AuthMessage) => {
  console.log('[Auth] Received auth message:', message);

  switch (message.type) {
    case AuthMessageType.AUTH_SUCCESS: {
      console.log('Auth success');
      setIsReady(true);
      break;
    }
    case AuthMessageType.AUTH_SIGNIN_TOKEN_REPLY: {
      if (signInTokenCallback && message.token) {
        signInTokenCallback(message.token);
      }
      break;
    }
    case AuthMessageType.AUTH_ERROR: {
      console.error('[Auth] Auth error:', message.error);
      authErrorCallback?.(message.error ?? {});
      break;
    }
    default: {
      console.warn('[Auth] Unknown auth message type:', message.type);
    }
  }
};
